export const DocumentRetrievalScope = {
  id: 1,
  site_name: 'test',
  country: 'Brazil',
  service_name: 'Test',
  project_type: '',
  additional_info: 'test add',
  scope_id: 1,
  client_price_usd: '200',
  client_price_gbp: '300',
  client_price_eur: '400',
  partner_price_usd: '500',
  partner_price_gbp: '600',
  partner_price_eur: '700',
  is_entity: true
};